import { useEffect } from "react";
import { getMessaging, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import notificationSound from "../assets/sound/notification.mp4";
import { playAppSound } from "../helpers/playAppSound";
import useChatStore from "../stores/chatStore";
import useAppStore from "../stores/appStore";

interface NotificationPayload {
  data?: {
    click_action?: string;
  }
  notification?: {
    title?: string;
    body?: string;
  };
}

const useOnMessage = () => {
  const { domain, focus, setDomainFocus } = useAppStore();
  const { setTargetMessageId } = useChatStore();

  useEffect(() => {
    const messaging = getMessaging();

    const truncateText = (
      text: string | undefined,
      maxLength: number,
    ): string => {
      if (!text) return "";
      return text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text;
    };

    const handleMessage = (payload: NotificationPayload) => {
      const notificationTitle = payload.notification?.title || "Notification";
      const notificationBody = truncateText(payload.notification?.body, 50);

      playAppSound(notificationSound).catch((error) => {
        console.error("Failed to play notification sound:", error);
      });

      const handleToastClick = () => {
        if (!payload?.data?.click_action) return;

        const queryParams = new URL(payload?.data?.click_action).searchParams;
        const messageId = queryParams.get("message_id");
        const targetDomain = queryParams.get("domain");
        const targetFocus = queryParams.get("focus");

        if (targetDomain && targetFocus && (focus !== targetFocus || domain !== targetDomain)) {
          setDomainFocus(targetDomain, targetFocus);
        }

        setTargetMessageId(messageId);


      }
      
      toast.info(`${notificationTitle}: ${notificationBody}`, {
        onClick: handleToastClick,
        closeOnClick: true
      });
    };

    const unsubscribe = onMessage(messaging, handleMessage);

    return () => {
      unsubscribe();
    };
  }, []);
};

export default useOnMessage;
